import React, { useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchFuelEfficiency } from '../../pages/FleetEdge/Fleetedgekpi';
import { FilterContext } from '../../context/Filter';

const Fueleff = () => {
    const { arn: parArn, childArn } = useContext(FilterContext);

    const { data, isLoading: loading, isError: error } = useQuery({
        queryKey: ['fuel-efficiency-q1', parArn, childArn],
        queryFn: () => fetchFuelEfficiency(parArn, childArn),
        enabled: !!(parArn || childArn),
    });

    if (loading) return <div>Loading fuel efficiency data...</div>;
    if (error) return <div>Error loading fuel efficiency data</div>;

    return (
        <div className='flex-col'>
            <div className='flex gap-4 mt-1 justify-center'>
                <div className='flex-col p-4 w-48 border-[2px] border-[#86EFAC] bg-[#ECFDF5] rounded-md text-center'>
                    <div className='text-[#16A34A] font-semibold'>LOW-LOW (LL)</div>
                    <div className='text-[#233D91] font-bold'>{data?.result["L-l"]}</div>
                </div>

                <div className='flex-col p-4 w-48 border-[2px] border-[#93C5FD] bg-[#EFF6FF] rounded-md text-center'>
                    <div className='text-[#3B82F6] font-semibold'>HIGH-LOW (HL)</div>
                    <div className='text-[#233D91] font-bold'>{data?.result["H-l"]}</div>
                </div>
            </div>

            <div className='flex gap-4 mt-2 justify-center mb-1'>
                <div className='flex-col p-4 w-48 border-[2px] border-[#FCA5A5] bg-[#FEF2F2] rounded-md text-center'>
                    <div className='text-[#EF4444] font-semibold'>LOW-HIGH (LH)</div>
                    <div className='text-[#233D91] font-bold'>{data?.result["L-h"]}</div>
                </div>

                <div className='flex-col p-4 w-48 border-[2px] border-[#C4B5FD] bg-[#F3F0FF] rounded-md text-center'>
                    <div className='text-[#7C3AED] font-semibold'>HIGH-HIGH (HH)</div>
                    <div className='text-[#233D91] font-bold'>{data?.result["H-h"]}</div>
                </div>
            </div>
        </div>
    );
};

export default Fueleff;
